import React, { useContext, useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import { GetModules } from './services/SystemDataService';
import './App.css';
import { AsTitlebar, MessageProvider, MessageModal } from '@adserve/adserve-react-components';
import HomePage from './pages/HomePage';
import CampaignPage from './pages/CampaignPage';
import { SystemSettingsContext } from './contexts/SystemSettingsContext';
import CampaignActionPage from './pages/CampaignActionPage';
import JetImportPage from './pages/JetImportPage';
import { VersionNo } from './constants/VersionNumber';
import { AirtimePlanningProvider } from './contexts/AirtimePlanningContext';
import { LiveContentDayReportPage } from './pages/LiveContentDayReport/LiveContentDayReportPage';
import { PerformanceProvider } from './contexts/PerformanceContext';
function App() {
    const { logo } = useContext(SystemSettingsContext);

    const [modules, setModules] = useState([]);
    const [loadingModules, setLoadingModules] = useState(true);
    const [modulesError, setModulesError] = useState('');
    const [noOfTries, setNoOfTries] = useState(0);
    const [moduleTitle, setModuleTitle] = useState('Campaign Manager');

    const gridStyle = {
        display: 'grid',
        gridTemplateAreas: "'header' 'content' 'footer'",
        gridTemplateRows: '50px 1fr 50px',
        gridTemplateColumns: '1fr',
        height: '100vh',
        width: '100vw',
        fontFamily: 'roboto'
    };

    const headerStyle = {
        gridArea: 'header',
        width: '100vw'
    };

    const contentStyle = {
        gridArea: 'content'
    };

    const footerStyle = {
        gridArea: 'footer',
        width: '100vw',
        height: '100%',
        background: 'linear-gradient(0deg, #1A1A1A 0%, #444343 100%)'
    };

    useEffect(() => {
        async function fetchModules() {
            const m = await GetModules();
            setModules(m);
        }

        fetchModules();
    }, []);

    const sleep = (ms) => {
        // eslint-disable-next-line no-undef
        return new Promise((resolve) => setTimeout(resolve, ms));
    };

    const loadModules = async () => {
        if (modules.length === 0 && noOfTries < 3) {
            try {
                GetModules().then((response) => {
                    if (response.length > 0) {
                        setModules(response);
                        const module = response.find((x) => x.shortCode === 'CMPMAN');
                        module?.name && setModuleTitle(module?.name);
                        setLoadingModules(false);
                    }
                });
                await sleep(1000);
            } finally {
                setNoOfTries(noOfTries + 1);
            }
        }
    };

    useEffect(() => {
        loadModules();

        if (modules.length === 0 && noOfTries === 3) {
            setModulesError('Unable to load modules, please refresh your browser');
        }
    }, [noOfTries, modules]);

    window.emptyGuid = '00000000-0000-0000-0000-000000000000';

    window.newGuid = (str) => {
        if (str === undefined || !str.length) str = '' + Math.random() * new Date().getTime() + Math.random();

        let c = 0;
        let r = '';

        for (let i = 0; i < str.length; i++) c = (c + (str.charCodeAt(i) * (i + 1) - 1)) & 0xfffffffffffff;

        str = str.substr(str.length / 2) + c.toString(16) + str.substr(0, str.length / 2);
        for (let i = 0, p = c + str.length; i < 32; i++) {
            if (i === 8 || i === 12 || i === 16 || i === 20) r += '-';

            c = p = str[(i ** i + p + 1) % str.length].charCodeAt(0) + p + i;
            if (i === 12) c = (c % 5) + 1;
            // 1-5
            else if (i === 16) c = (c % 4) + 8;
            // 8-B
            else c %= 16; // 0-F

            r += c.toString(16);
        }
        return r;
    };

    return (
        <MessageProvider>
            <div style={gridStyle}>
                <div style={headerStyle} title={VersionNo}>
                    <AsTitlebar
                        moduleTitle={moduleTitle}
                        title={moduleTitle}
                        animationDuration={500}
                        moduleLinks={modules}
                        loadingModules={loadingModules}
                        moduleError={modulesError}
                        logo={logo}
                    />
                </div>
                <div style={contentStyle}>
                    <AirtimePlanningProvider>
                        <PerformanceProvider>
                            <Switch>
                                <Route exact path='/' component={HomePage} />
                                <Route exact path='/campaigns/create' component={CampaignPage} />
                                <Route exact path='/campaigns/details/:campaignId?' component={CampaignPage} />
                                <Route exact path='/campaigns/action' component={CampaignActionPage} />
                                <Route exact path='/jet/import' component={JetImportPage} />
                                <Route exact path='/reports/livecontent' component={LiveContentDayReportPage} />
                            </Switch>
                        </PerformanceProvider>
                    </AirtimePlanningProvider>
                </div>
                <div style={footerStyle} />
            </div>
            <MessageModal />
        </MessageProvider>
    );
}

export default App;
